import { FC } from 'react';
import { TbLayoutGrid } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { EmptySection } from '@/shared';

const EmptyJoinableWorkspaces: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <EmptySection
            height='100%'
            icon={<TbLayoutGrid size='67.5%' style={{ color: token.colorTextTertiary }} />}
            label='No Workspace Invitations'
            description='Invitations to other Workspaces will appear here.'
        />
    );
};

export default EmptyJoinableWorkspaces;
